jQuery(document).ready(function () {

    jQuery(function ($) {

        $(document).ajaxStart(function () {

            if ($('body').hasClass('members') || $('body').hasClass('groups')) {

                $('.top-cd-overlay').addClass('is-visible');
                $('.top-cd-overlay').addClass('is-loading');
                $('.cd-searchbar-nav').addClass('updating');
            }

        }).ajaxStop(function () {

            if (!$('.cd-panel').hasClass('is-visible')) {
                $('.top-cd-overlay').removeClass('is-visible');
            }
            $('.top-cd-overlay').removeClass('is-loading');
            $('.cd-searchbar-nav').removeClass('updating');
        });

        // On affiche ou masque la liste des membres ou la carte Google maps
        var map_active = false;

        $("#expand-map").on('click', function () {

            $('.cd-searchbar-nav').removeClass("expanded");
            $('html').removeClass("noscroll");

            if (map_active) {

                map_active = false;
                $("#buddypress").removeClass('show-map');

            } else {

                map_active = true;
                $("#buddypress").addClass('show-map');

            }
        });

        $('#search-form').bind("keypress", function (e) {
            if (e.keyCode === 13) {
                return false;
            }
        });


        // gestion de l'affichage de la carte Google Maps
        function display_map() {
            if (map_active) {
                $("#buddypress").addClass('show-map');
            } else {
                $("#buddypress").removeClass('show-map');

                // On affiche un block dans la zone filtres pour indiquer le nombre de résultats
                var flash_class = 'error';
                var bp_status_text = $('#message p').text();

                if (bp_status_text === '') {

                    // means there are some results
                    flash_class = 'notice';
                    bp_status_text = $('#member-dir-count-top').text() + ' <a class="expander-trigger" href="javascript:void(0)">Afficher les résultats</a>';
                }

                var alertBox = $('<div id="bp-status" class="flash-' + flash_class + '"><span>' + bp_status_text + '</span></div>');
                $('#search-status').html(alertBox);
            }
        }


        /*
         * AJAX update members loop
         * related tpl: buddypress/members/tpl_search.php
         */

        // for test (codyhouse temporaire)
        $('#search_tag').removeClass('empty');

        // variables utilisées pour le cart
        var selected_text;
        var tagsList = '';
        var search_field;
        var value;

        function update_cart() {

            tagsList = $('<li id="tag_' + search_field + '" data-select="' + search_field + '"  data-value="' + value + '" class="product"><div class="product-details"><h3><a href="#0">' + search_field + '</a></h3><span class="price">' + selected_text + '</span><div class="actions"><a href="#0"  id="' + search_field + '" class="delete-item">Supprimer</a></div></div></li>');


            var cartWrapper = $('.cd-cart-container');
            var cartIsEmpty = cartWrapper.hasClass('empty');

            /**
             * On ajoute un tag dans le cart seulement si la valeur du select n'est pas 0 (par défaut)
             * Condition nécéssaire pour supprimer un tag du cart sans refaire d'appel AJAX quand le select est remis à 0 ou si le <input> n'est pas vide
             */

            var $search_field_element = $("#" + search_field);

            if ($search_field_element.val() !== 0 && $.trim($search_field_element.val()).length > 0) {
                //if ($("#" + search_field).val() !== 0) {

                // On teste si l' ID de l'élément <li> correspondant existe ou pas dans le cart. Si il existe, on remplace le <li>, sinon on le créé.
                if ($('#tag_' + search_field).length === 0) {

                    cartList.prepend(tagsList);

                    // Code codyhouse - update number of items
                    updateCartCount(cartIsEmpty);

                    // Code codyhouse - show cart
                    cartWrapper.removeClass('empty');

                } else if ($('#tag_' + search_field).length > 0) {

                    // le <li> avec le mexiste dans le block, on le remplace par lélément recherché
                    $('#search_tag_list #tag_' + search_field).replaceWith(tagsList);

                    // show cart
                    cartWrapper.removeClass('empty');


                }
            }
        }

        /*
         * AJAX update groups loop !
         * related tpl: buddypress/members/tpl_search.php
         */

        var form_class;
        var post_type = '';
        var action;
        var members = false;
        var groups = false;


        // On récupère une class du formulaire pour savoir si on est dans membres, structures, ou films pour affecter des valeurs à transmettre en ajax (post_type, action, etc.)
        if ($('#search-form').hasClass('form-members')) {

            post_type = '';
            action = 'update_members_loop';
            members = true;

        } else if ($('#search-form').hasClass('form-structures')) {

            post_type = 'fiche-structures';
            action = 'update_groups_loop';
            groups = true;

        } else if ($('#search-form').hasClass('form-catalogue')) {

            post_type = 'fiche-film';
            action = 'update_groups_loop';
            groups = true;

        }


        // var members
        var ville;
        var metiers;
        var genres;
        var competences;
        var materiel;
        var departement;

        // var structures
        var nom;
        var types_activite_structure;

        // var films
        var genre;
        var registres;
        var sujets;
        var titre_film;

        function ajax_filter_submit(id, value, selected_text) {

            // on récupère le contenu des champs <select>
            search_field = id;

            // si le <select> esr remis à 0 par l'utilisateur, on met à jour le compteur du cart et on supprime l'élément recherché
            if (value === '0' || value.length === 0) {

                var product_to_remove = $('#search_tag_list li#tag_' + search_field);
                removeProduct(product_to_remove);

                // on supprime la class css "highlight" aux filtres actifs
                $('#' + search_field).removeClass("highlight");

            } else {

                // on attribue la class css "highlight" aux filtres actifs
                $('#' + search_field).addClass("highlight");
            }

            /**
             * On assigne les valeurs des <select> et <input> pour les envoyer en AJAX
             * TODO : optimiser ce code. Fonctionne très bien mais redondant, trop de else if ()
             */

            if (search_field === 'nom') {

                nom = value;

            } else if (search_field === 'ville') {

                ville = value;

            } else if (search_field === 'departement') {

                departement = value;

            } else if (search_field === 'types_activite_structure') {

                types_activite_structure = value;

            } else if (search_field === 'metiers') {

                metiers = value;

            } else if (search_field === 'competences') {

                competences = value;

            } else if (search_field === 'genres') {

                genres = value;

            } else if (search_field === 'materiel') {

                materiel = value;

            } else if (search_field === 'genre') {

                genre = value;

            } else if (search_field === 'registres') {

                registres = value;

            } else if (search_field === 'sujets') {

                sujets = value;

            }

            function hide_departement_select(departement, ville) {
                if (departement == null || departement === '' || departement === '0') {
                    if (ville !== '' && ville !== '0' && ville != null) {
                        $('#search-form .input-select-departement').hide();
                    } else {
                        $('#search-form .input-select-departement').show();
                    }
                } else {
                    $('#search-form .input-select-departement').show();
                }
            }

            // AJAX !
            jQuery.ajax({
                type: "POST",
                url: ajaxurl,
                data: {

                    // data en commun pour membres, structures et catalogue
                    action: action,
                    post_type: post_type,
                    nom: nom,
                    ville: ville,
                    genres: genres,
                    departement: departement,
                    competences: competences,
                    materiel: materiel,
                    metiers: metiers,

                    // datas pour structure
                    types_activite_structure: types_activite_structure,

                    // datas Catalogue FILMS
                    genre: genre,
                    registres: registres,
                    sujets: sujets

                },
                beforeSend: function () {

                },
                complete: function () {

                },
                success: function (data, textStatus, XMLHttpRequest) {

                    // refresh de la liste des groupes
                    if (groups) {

                        hide_departement_select(departement, ville);

                        $('#buddypress #groups-directory-form').html(data);
                        
                        initMap();

                    } else if (members) {

                        hide_departement_select(departement, ville);

                        // refresh de la liste des membres
                        $('#buddypress #members-directory-form').html(data);
                        initMap();
                        display_map();
                    }

                    /**
                     * mise à jour du cart (le block qui contient les éléments recherchés)
                     * Condition : Lorsque qu'un <select> est remis à 0, cela rédéclenche un appel ajax pour remettre la liste à jour. 
                     * Dans ce cas, on ne veut pas réafficher le tag qui aura une valeur 0 pour le <select> ou vide pour le champ <input>.
                     */
                    if (value !== '0') {

                        update_cart();
                    }

                },
                error: function (MLHttpRequest, textStatus, errorThrown) {
                    console.log(errorThrown);
                }

            });
        }

        // On traite le formulaire en AJAX à chaque changement dans un champ <input>
//        $('.bp_filters_input').on('input', function () {
//
//            var id = $(this).attr("id");
//            value = $(this).val();
//            selected_text = $(this).val();
//
//            // Fonction qui envoie les données du formulaires en AJAX
//            ajax_filter_submit(id, value, selected_text);
//
//        });

        // On traite le formulaire en AJAX à chaque changement dans un <select>
        $(".bp_filters_select").change(function () {

            // On passe à la fonction l'id, le texte et la valeur du <select>
            var id = $(this).attr("id");
            value = $(this).val();
            selected_text = $('option:selected', this).text();

            // Fonction qui envoie les données du formulaires en AJAX
            ajax_filter_submit(id, value, selected_text);

        });

        /*
         * 
         * @type Function
         * On exécute une fonction quand l'utilisateur a arrêté de saisir du texte dans le champ <input> après un certain délai.
         * 
         */

        $.fn.delayKeyup = function (callback, ms) {
            var timer = 0;
            var el = $(this);
            $(this).keyup(function () {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback(el);
                }, ms);
            });
            return $(this);
        };

        $('.bp_filters_input').delayKeyup(function (el) {
  
            var id = el.attr("id");
            
            // TODO : pourquoi 2 variables avec même valeurs ??
            value = el.val();
            console.log('value = ' + value);
            selected_text = el.val();

            // Fonction qui envoie les données du formulaires en AJAX
            ajax_filter_submit(id, value, selected_text);
        }, 1100);



        // Bouton réinitialisation de tous les <select>
        $("#dropselection-reinit a").click(function () {
//            console.log('réinitialisation de tous les <select>');
//            $("#search-members-form select").val("0");
//            $('.search-members-form select').removeClass("highlight");
//            $(".bp_filters").trigger('change');
        });
        /* all codyhouse main.js demo code below  */

        // https://codyhouse.co/gem/add-to-cart-interaction/

        /* jshint ignore:start */

        var cartWrapper = $('.cd-cart-container');

        if (cartWrapper.length > 0) {
            //store jQuery objects
            var cartBody = cartWrapper.find('.body');
            var cartList = cartBody.find('ul').eq(0);
            //var cartTotal = cartWrapper.find('.checkout').find('span');
            var cartTrigger = cartWrapper.children('.cd-cart-trigger');
            var cartCount = cartTrigger.children('.count');
            var cartCheckout = cartWrapper.find('.checkout');

            var searchStatus = $('#wrapper').find('#search-status');

            var addToCartBtn = $('.cd-add-to-cart');
            var undo = cartWrapper.find('.undo');
            var undoTimeoutId;

            // open/close cart
            cartTrigger.on('click', function (event) {
                event.preventDefault();
                toggleCart();
            });

            // close cart when clicking on the .cd-cart-container::before (bg layer)
            cartWrapper.on('click', function (event) {
                if ($(event.target).is($(this)))
                    toggleCart(true);
            });

            // open search filters block when clicking on the .cd-cart checkout btn
            cartCheckout.on('click', function (event) {
                event.preventDefault();
                toggleCart();

                // manage search form display
                $('.cd-searchbar-nav').toggleClass("expanded");
                $('.cd-secondary-nav').toggleClass("expanded");
                $('html').toggleClass("noscroll");

            });

            /**
             * On supprime l'élément du cart
             * On remet le <select> à 0 ou on vide le champ <input>
             * Ensuite, on relance la recherche pour mettre à jour la liste
             * Le carte est mis à jour avec la fonction update_cart()
             */
            cartList.on('click', '.delete-item', function (event) {

                event.preventDefault();
                var selected_id = $(this).attr('id');

                // On détecte si c'est le <select> qui est remis à 0 ou si le champ <input> est vidé par l'utilisateur
                if ($('#' + selected_id).is('input')) {

                    $('#' + selected_id).val('').trigger("input");

                } else if ($('#' + selected_id).is('select')) {

                    $('#' + selected_id + ' option:first').prop('selected', true);
                    $('#' + selected_id).trigger('change');

                }

                // on supprime la class css "highlight" aux <select> remis à 0
                $('#' + selected_id).removeClass("highlight");

            });

        }

        function toggleCart(bool) {
            var cartIsOpen = (typeof bool === 'undefined') ? cartWrapper.hasClass('cart-open') : bool;

            if (cartIsOpen) {
                cartWrapper.removeClass('cart-open');
                //reset undo
                clearInterval(undoTimeoutId);
                undo.removeClass('visible');
                cartList.find('.deleted').remove();

                // manage search form display
                //$('.cd-searchbar-nav').toggleClass("expanded");
                //$('.cd-secondary-nav').toggleClass("expanded");
                //$('html').toggleClass("noscroll");

                setTimeout(function () {
                    cartBody.scrollTop(0);
                    //check if cart empty to hide it
                    if (Number(cartCount.find('li').eq(0).text()) === 0)
                        cartWrapper.addClass('empty');
                }, 500);
            } else {
                cartWrapper.addClass('cart-open');
            }
        }

        function addToCart(trigger) {
        }

        function addProduct() {
        }

        function removeProduct(product) {

            clearInterval(undoTimeoutId);
            cartList.find('.deleted').remove();

            var topPosition = product.offset().top - cartBody.children('ul').offset().top;
            var productQuantity = Number(product.find('.quantity').find('select').val());

            product.css('top', topPosition + 'px').addClass('deleted');

            updateCartCount(true, -productQuantity);

            //wait 8sec before completely remove the item
            undoTimeoutId = setTimeout(function () {
                undo.removeClass('visible');
                cartList.find('.deleted').remove();
            }, 0);
        }

        function updateCartCount(emptyCart, quantity) {
            // incrémentation compteur produit


            if (typeof quantity === 'undefined') {
                var actual = Number(cartCount.find('li').eq(0).text()) + 1;
                var next = actual + 1;

                if (emptyCart) {
                    cartCount.find('li').eq(0).text(actual);
                    cartCount.find('li').eq(1).text(next);
                } else {
                    cartCount.addClass('update-count');
                    cartCount.find('li').eq(0).text(actual);
                    cartCount.removeClass('update-count');
                    cartCount.find('li').eq(1).text(next);

                }

            } else {
                // On définit la var quantity car le code codyhouse gère la quantité de produits (pas utile ici) !!!
                quantity = -1;
                var actual = Number(cartCount.find('li').eq(0).text()) + quantity;
                var next = actual + 1;

                cartCount.find('li').eq(0).text(actual);
                cartCount.find('li').eq(1).text(next);
            }
        }

//        function updateCartTotal(price, bool) {
//            bool ? cartTotal.text((Number(cartTotal.text()) + Number(price)).toFixed(2)) : cartTotal.text((Number(cartTotal.text()) - Number(price)).toFixed(2));
//        }

        /* jshint ignore:end */

        /* end codyhouse js demo code  */

    });

});